import type { ReactNode } from 'react';
import { Text } from '@/components/ui/text';

/**
 * The confirm dialog's subtitle — the one place its typography and ink live.
 *
 * `ConfirmationModal` wraps this around whatever `modals.confirm` was given, so a
 * call site passes the sentence and nothing else. That is the point: while each of
 * the 16 sites carried its own copy of the wrapper, the copy said
 * `variant="h3" color="text-primary"` — 3.43rem (larger than the 24px title) in
 * `--color-primary` (#FFFFFF), which is invisible on the dialog's light paper. The
 * modal could not correct it either, since Tailwind utilities sit above MUI's
 * emotion layer (ADR 0017). `confirmMessageInk.test.ts` keeps the wrapper here.
 *
 * `c16` is the ink because it diverges per mode: dark on the light paper (c1),
 * light on the dark one (c37). A flat token cannot read on both.
 *
 * Rendered as a `div` rather than the `<p>` body1 maps to — EpisodeLineModal sets a
 * `LineLabel` chip (a styled div) beside its text, which a `<p>` cannot contain.
 */
export const ConfirmMessage = ({ children }: { children?: ReactNode }) => (
    <Text as="div" variant="body1" color="text-c16">
        {children}
    </Text>
);
